export default function mapObjectToEntries(obj) {
    return Object.entries(obj);
}
//# sourceMappingURL=map-object-to-entries.js.map